// extracted by mini-css-extract-plugin
module.exports = {"base":"TrialDetailsOverview_base__keI1E"};